import { render, staticRenderFns } from "./RolePermissionsOverviewItem.vue?vue&type=template&id=54d3fa5b&scoped=true&"
import script from "./RolePermissionsOverviewItem.vue?vue&type=script&lang=js&"
export * from "./RolePermissionsOverviewItem.vue?vue&type=script&lang=js&"
import style0 from "./RolePermissionsOverviewItem.vue?vue&type=style&index=0&id=54d3fa5b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d3fa5b",
  null
  
)

export default component.exports